class AwardsListing {
  constructor(el) {
    this.endpoint = window.ddb.api.ajax_url;
    this.awardsAction = window.ddb.api.awards.action;
    this.awardsToken = window.ddb.api.awards.token;

    this.$el = $(el);
    this.$container = this.$el.find('.card-container');
    this.$loadhandler = this.$el.find('.awards-load-more');

    this._isLoading = false;
    this._count = this.$container.find('.card-container__item').length; // @TODO: should change to get the data from cardcontainer component instead of checking from DOM.

    if (this.$loadhandler) {
      this.nextPage = this.$loadhandler.data('page');
      this.$loadhandler.on('click', AwardsListing.prototype.loadMore.bind(this));
    }
  }

  generateHTMLItem(data, idx) {
    const figure = (data.image) ? `
      <figure class="card__image image is-square">
        <img src="${data.image}" class="image-block " alt="${data.title}">
      </figure>
    ` : '';

    return `
      <li class="card-container__item">
        <article class="card card--award" data-speed="${.5 * ((idx % 2 == 0) ? 1 : -1)}">
          ${figure}
          <div class="card__content">
            <header>
              <span>${data.title}</span>
            </header>
            <p>${data.description}</p>
          </div>
        </article>
      </li>
    `;
  }

  async loadMore() {
    if (this._isLoading) return;

    try {
      this.setLoading(true);

      const httpRequest = await this.fetch();
      const result = httpRequest.data;

      if (result.data.list) {
        result.data.list.forEach((item) => {
          let html = this.generateHTMLItem(item, this._count);

          const cardContainer = this.$container.data('ddb.cardcontainer');
          cardContainer.add(html);
          this._count += 1;
        });
      }

      if (result.data.pagination.next_page == 0) { // at the end of pages.
        this.$loadhandler.fadeOut();
      } else {
        this.nextPage = result.data.pagination.next_page;
        this.setLoading(false);
      }
    } catch (error) {
      if (window.ddb.debug) {
        console.log('error', error);
      }

      this.setLoading(false);
    }
  }

  setLoading(state) {
    this._isLoading = !!state;
    this.$loadhandler.buttonloader('loading', !!state);
  }

  async fetch() {
    return axios.post(this.endpoint, Qs.stringify({
      action: this.awardsAction,
      page: this.nextPage,
      token: this.awardsToken,
    }));
  }
}

module.exports = AwardsListing;
